(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-bundle-builder"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('premium-bundle-builder')) return;
  class PremiumBundleBuilder extends HTMLElement {
    static queue = Promise.resolve();
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.cartQuantities = new Map();
      this.stockLimits = new Map();
      this.knownVariants = new Map();
      this.cartReady = false;
      this.cartRequest = null;
      this.categories = new Map();
      this.querySelectorAll('[data-category]').forEach(el => {
        const category = {id:el.dataset.category, name:el.dataset.name, min:Number(el.dataset.min), max:Number(el.dataset.max), el, items:new Map(), products:new Map(), content:null};
        this.categories.set(category.id, category);
        el.querySelector('[data-open]').disabled = false;
      });
      this.picker = this.querySelector('.bb-picker');
      this.host = this.querySelector('[data-picker-host]');
      this.host.replaceChildren();
      this.picker.hidden = true;
      this.querySelectorAll('[data-open]').forEach(button => button.setAttribute('aria-expanded', 'false'));
      this.addButton = this.querySelector('[data-add]');
      this.buttonText = this.addButton.textContent;
      this.status = this.querySelector('[data-status]');
      this.quickView = this.querySelector('[data-qv]');
      this.quickViewCard = null;
      this.quickViewCategory = null;
      this.busy = false;
      this.locked = false;
      this.active = null;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      try { this.formatter = new Intl.NumberFormat(this.dataset.locale || 'en', {style:'currency', currency:this.dataset.currency}); }
      catch (_) { this.formatter = new Intl.NumberFormat('en', {style:'currency', currency:this.dataset.currency}); }
      this.addEventListener('click', event => this.click(event), {signal});
      this.addEventListener('change', event => {
        if (event.target.matches('[data-variant]')) this.renderProducts(this.categories.get(this.active));
      }, {signal});
      this.addEventListener('keydown', event => {
        const opener = event.target.closest?.('[data-qv-open]');
        if (opener && (event.key === 'Enter' || event.key === ' ')) {
          event.preventDefault();
          const card = opener.closest('[data-product]');
          if (card) this.openQuickView(card);
          return;
        }
        if (event.key === 'Escape' && this.quickView && !this.quickView.hidden) {
          event.preventDefault();
          this.closeQuickView();
        } else if (event.key === 'Escape' && this.active) {
          event.preventDefault();
          this.close();
        }
      }, {signal});
      document.addEventListener('shopify:block:select', event => {
        const category = this.categories.get(event.detail.blockId);
        if (category) this.open(category.id, false);
      }, {signal});
      document.addEventListener('bundle:selection-changed', () => this.render(), {signal});
      document.addEventListener('cart:updated', event => {
        if (Array.isArray(event.detail?.cart?.items)) this.acceptCart(event.detail.cart);
        else if (!this.busy) this.checkCart();
      }, {signal});
      window.addEventListener('focus', () => { if (!this.busy) this.checkCart(); }, {signal});
      // Read inventory for the initial product pages without mounting their cards.
      this.querySelectorAll('[data-category] template').forEach(template => {
        template.content.querySelectorAll('[data-stock]').forEach(card => {
          Object.entries(JSON.parse(card.dataset.stock || '{}')).forEach(([id, limit]) => this.stockLimits.set(id, limit));
          JSON.parse(card.dataset.variants || '[]').forEach(variant => this.knownVariants.set(String(variant.id), variant));
        });
      });
      this.render();
      this.checkCart();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.animation?.cancel();
    }
    remaining(id) {
      const limit = this.stockLimits.get(String(id));
      if (!this.cartReady) return 0;
      // For a restored paginated item, Shopify validates stock on the next addition.
      if (limit === null || limit === undefined) return Infinity;
      return limit - (this.cartQuantities.get(String(id)) || 0);
    }
    stockValid() { return this.cartReady; }
    acceptCart(cart) {
      this.cart = cart;
      this.cartQuantities = new Map();
      this.categories.forEach(category => category.items.clear());
      cart.items.forEach(line => {
        const id = String(line.variant_id || line.id);
        this.cartQuantities.set(id, (this.cartQuantities.get(id) || 0) + line.quantity);
        const properties = line.properties || {};
        if (properties._bb_section !== this.dataset.section) return;
        const category = this.categories.get(properties._bb_category);
        if (!category) return;
        let item = category.items.get(id);
        if (!item) {
          item = {id, quantity:0, original:0, final:0, discounts:new Set(),
            variant:this.knownVariants.get(id) || {id, available:true, price:line.original_price},
            title:line.product_title || line.title, variantTitle:line.variant_title === 'Default Title' ? '' : line.variant_title,
            image:line.featured_image?.url || line.image || '', categoryId:category.id, categoryName:category.name};
          category.items.set(id, item);
        }
        item.quantity += line.quantity;
        item.original += line.original_line_price;
        item.final += line.final_line_price;
        (line.line_level_discount_allocations || []).forEach(allocation => {
          if (allocation.discount_application?.title) item.discounts.add(allocation.discount_application.title);
        });
      });
      if (cart.currency && cart.currency !== this.dataset.currency) {
        this.dataset.currency = cart.currency;
        this.formatter = new Intl.NumberFormat(this.dataset.locale || 'en', {style:'currency', currency:cart.currency});
      }
      this.cartReady = true;
      this.querySelector('[data-stock-retry]').hidden = true;
      this.render();
    }
    async refreshCart() {
      const response = await fetch(`${this.dataset.cartUrl}.js`, {credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('Your cart could not be refreshed.');
      const cart = await response.json();
      if (!Array.isArray(cart.items)) throw new Error('Invalid cart response.');
      document.dispatchEvent(new CustomEvent('cart:updated', {detail:{cart, source:'premium-bundle-builder'}}));
      return cart;
    }
    checkCart() {
      const task = async () => {
        if (!this.isConnected) return;
        try { await this.refreshCart(); }
        catch (_) {
          this.cartReady = false;
          this.status.textContent = 'Your cart could not be refreshed. Please try again.';
          this.querySelector('[data-stock-retry]').hidden = false;
          this.render();
        }
      };
      const result = PremiumBundleBuilder.queue.then(task);
      PremiumBundleBuilder.queue = result.catch(() => {});
      return result;
    }
    money(cents) { return this.formatter.format(cents / 100); }
    count(category) { return [...category.items.values()].reduce((sum, item) => sum + item.quantity, 0); }
    allItems() { return [...this.categories.values()].flatMap(category => [...category.items.values()]); }
    valid() { return this.stockValid() && this.categories.size > 0 && this.allItems().length > 0 && [...this.categories.values()].every(category => category.min <= category.max && this.count(category) >= category.min && this.count(category) <= category.max); }
    click(event) {
      const qvClose = event.target.closest('[data-qv-close]');
      if (qvClose && this.contains(qvClose)) { this.closeQuickView(); return; }

      const qvChange = event.target.closest('[data-qv-change]');
      if (qvChange && this.contains(qvChange)) {
        if (!this.quickViewCard || !this.quickViewCategory) return;
        const select = this.quickViewCard.querySelector('[data-variant]');
        const qvSelect = this.querySelector('[data-qv-variant]');
        if (qvSelect && qvSelect.value && select.value !== qvSelect.value) {
          select.value = qvSelect.value;
          this.renderProducts(this.quickViewCategory);
        }
        this.changeQuantity(this.quickViewCategory, select.value, Number(qvChange.dataset.qvChange), this.quickViewCard)
          .finally(() => this.renderQuickView());
        return;
      }

      const qvPrev = event.target.closest('[data-qv-prev]');
      if (qvPrev && this.contains(qvPrev)) { this.moveQuickViewGallery(-1); return; }
      const qvNext = event.target.closest('[data-qv-next]');
      if (qvNext && this.contains(qvNext)) { this.moveQuickViewGallery(1); return; }

      const opener = event.target.closest('[data-qv-open]');
      if (opener && this.contains(opener)) {
        const card = opener.closest('[data-product]');
        if (card) this.openQuickView(card);
        return;
      }

      const button = event.target.closest('button');
      if (!button || !this.contains(button) || button.disabled) return;
      if (button.matches('[data-open]')) {
        const id = button.closest('[data-category]').dataset.category;
        if (this.active === id) this.close(); else this.open(id);
      } else if (button.matches('[data-close]')) this.close();
      else if (button.matches('[data-change]')) {
        const row = button.closest('[data-item-key]');
        const category = this.categories.get(row ? row.dataset.categoryId : this.active);
        const product = row ? null : button.closest('[data-product]');
        const id = row ? row.dataset.itemKey : product.querySelector('[data-variant]').value;
        this.changeQuantity(category, id, Number(button.dataset.change), product);
      } else if (button.matches('[data-stock-retry]')) {
        this.status.textContent = '';
        this.checkCart();
      } else if (button.matches('[data-load]')) this.loadMore(this.categories.get(this.active));
      else if (button.matches('[data-add]')) this.submit();
    }

    openQuickView(card) {
      const category = this.categories.get(this.active);
      if (!category || !card) return;
      this.quickViewCard = card;
      this.quickViewCategory = category;
      const qvSelect = this.querySelector('[data-qv-variant]');
      const cardSelect = card.querySelector('[data-variant]');
      const product = category.products.get(card.dataset.product);
      qvSelect.replaceChildren();
      product.variants.forEach(variant => {
        const option = document.createElement('option');
        option.value = String(variant.id);
        option.textContent = variant.title + (variant.available ? '' : ' — Sold out');
        option.disabled = !variant.available;
        option.selected = String(variant.id) === String(cardSelect.value);
        qvSelect.append(option);
      });
      this.querySelector('[data-qv-variant-wrap]').hidden = card.dataset.default === 'true';
      this.buildQuickViewGallery(card);
      qvSelect.onchange = () => {
        cardSelect.value = qvSelect.value;
        this.renderProducts(category);
        this.renderQuickView();
      };
      this.quickView.hidden = false;
      this.quickView.setAttribute('aria-hidden', 'false');
      document.body.classList.add('bb-qv-lock');
      this.renderQuickView();
      requestAnimationFrame(() => this.querySelector('.bb-qv-close')?.focus({preventScroll:true}));
    }

    buildQuickViewGallery(card) {
      const track = this.querySelector('[data-qv-track]');
      const dots = this.querySelector('[data-qv-dots]');
      const urls = [...card.querySelectorAll('[data-qv-gallery-image]')]
        .map(el => el.dataset.qvGalleryImage)
        .filter(Boolean);
      const fallback = card.querySelector('img')?.src;
      if (!urls.length && fallback) urls.push(fallback);
      track.replaceChildren();
      dots.replaceChildren();
      urls.forEach((src, index) => {
        const slide = document.createElement('div');
        slide.className = 'bb-qv-slide';
        const img = document.createElement('img');
        img.src = src;
        img.alt = card.dataset.title || '';
        img.loading = index === 0 ? 'eager' : 'lazy';
        img.decoding = 'async';
        slide.append(img);
        track.append(slide);
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'bb-qv-dot';
        dot.setAttribute('aria-label', `Image ${index + 1}`);
        dot.setAttribute('aria-current', index === 0 ? 'true' : 'false');
        dot.addEventListener('click', () => track.scrollTo({left:index * track.clientWidth, behavior:'smooth'}));
        dots.append(dot);
      });
      const multiple = urls.length > 1;
      this.querySelector('[data-qv-prev]').hidden = !multiple;
      this.querySelector('[data-qv-next]').hidden = !multiple;
      dots.hidden = !multiple;
      track.scrollLeft = 0;
      track.onscroll = () => {
        const index = Math.max(0, Math.min(urls.length - 1, Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
        [...dots.children].forEach((dot, i) => dot.setAttribute('aria-current', i === index ? 'true' : 'false'));
      };
    }

    moveQuickViewGallery(direction) {
      const track = this.querySelector('[data-qv-track]');
      if (!track || !track.children.length) return;
      const width = Math.max(1, track.clientWidth);
      const current = Math.round(track.scrollLeft / width);
      const next = Math.max(0, Math.min(track.children.length - 1, current + direction));
      track.scrollTo({left:next * width, behavior:'smooth'});
    }

    closeQuickView() {
      if (!this.quickView || this.quickView.hidden) return;
      this.quickView.hidden = true;
      this.quickView.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('bb-qv-lock');
      this.quickViewCard = null;
      this.quickViewCategory = null;
    }

    renderQuickView() {
      const card = this.quickViewCard;
      const category = this.quickViewCategory;
      if (!card || !category || this.quickView.hidden) return;
      const cardSelect = card.querySelector('[data-variant]');
      const qvSelect = this.querySelector('[data-qv-variant]');
      if (qvSelect?.value && cardSelect.value !== qvSelect.value) cardSelect.value = qvSelect.value;
      const data = this.variantData(category, card, cardSelect.value);
      if (!data) return;
      const {variant, product} = data;
      const quantity = category.items.get(String(variant.id))?.quantity || 0;
      const full = this.count(category) >= category.max;
      const subscription = card.dataset.subscription === 'true';
      this.querySelector('[data-qv-title]').textContent = card.dataset.title || '';
      this.querySelector('[data-qv-price]').textContent = this.money(variant.price);
      this.querySelector('[data-qv-description-output]').textContent = card.querySelector('[data-qv-description]')?.textContent?.trim() || '';
      const fullLink = this.querySelector('[data-qv-full]');
      fullLink.href = card.querySelector('[data-qv-url]')?.href || '#';
      this.querySelector('[data-qv-quantity]').textContent = quantity;
      const minus = this.querySelector('[data-qv-change="-1"]');
      const plus = this.querySelector('[data-qv-change="1"]');
      minus.disabled = this.busy || this.locked || !this.cartReady || quantity === 0;
      plus.disabled = this.busy || this.locked || !this.cartReady || full || !variant.available || subscription || this.remaining(variant.id) <= 0;
      this.querySelector('[data-qv-availability]').textContent =
        subscription ? 'Subscription required · Not available in this builder' :
        !variant.available ? 'Sold out' :
        !this.cartReady ? 'Checking availability…' :
        this.remaining(variant.id) <= 0 ? 'Stock limit reached · Includes items in your cart' :
        full ? 'Category limit reached' : 'Available · Add directly to your bundle';
    }

    registerProducts(category, container) {
      container.querySelectorAll('[data-product]').forEach(card => {
        if (category.products.has(card.dataset.product)) { card.remove(); return; }
        const stock = JSON.parse(card.dataset.stock || '{}');
        Object.entries(stock).forEach(([id, limit]) => this.stockLimits.set(id, limit));
        card.removeAttribute('data-stock');
        const variants = JSON.parse(card.dataset.variants);
        variants.forEach(variant => this.knownVariants.set(String(variant.id), variant));
        card.removeAttribute('data-variants');
        category.products.set(card.dataset.product, {card, variants, image:card.querySelector('img')?.getAttribute('src') || ''});
      });
    }
    async open(id, focus = true) {
      if (this.busy || this.locked) return;
      const category = this.categories.get(id);
      if (!category) return;
      this.animation?.cancel();
      if (this.active) this.categories.get(this.active).el.querySelector('[data-open]').setAttribute('aria-expanded', 'false');
      if (!category.content) {
        category.content = category.el.querySelector('template').content.firstElementChild.cloneNode(true);
        this.registerProducts(category, category.content);
        category.content.querySelector('[data-load]').hidden = !category.content.querySelector('[data-next]');
      }
      this.active = id;
      this.host.replaceChildren(category.content);
      this.querySelector('[data-picker-title]').textContent = category.name;
      category.el.querySelector('[data-open]').setAttribute('aria-expanded', 'true');
      this.picker.hidden = false;
      this.renderProducts(category);
      this.renderPickerNote(category);
      if (!this.reducedMotion.matches) this.animation = this.picker.animate([{opacity:0, transform:'translateY(-6px)'},{opacity:1, transform:'translateY(0)'}], {duration:180, easing:'ease-out'});
      if (focus) {
        this.querySelector('[data-picker-title]').focus({preventScroll:true});
        this.picker.scrollIntoView({behavior:this.reducedMotion.matches ? 'instant' : 'smooth', block:'start'});
      }
    }
    async close() {
      if (!this.active) return;
      const id = this.active;
      this.animation?.cancel();
      if (!this.reducedMotion.matches) {
        this.animation = this.picker.animate([{opacity:1},{opacity:0}], {duration:130});
        try { await this.animation.finished; } catch (_) { return; }
      }
      if (this.active !== id) return;
      const button = this.categories.get(id).el.querySelector('[data-open]');
      button.setAttribute('aria-expanded', 'false');
      this.picker.hidden = true;
      this.active = null;
      button.focus({preventScroll:true});
    }
    variantData(category, card, id) {
      const product = category.products.get(card.dataset.product);
      const variant = product.variants.find(v => String(v.id) === String(id));
      if (!variant) return null;
      return {variant, product};
    }
    changeQuantity(category, id, delta, card) {
      if (!category || this.busy || this.locked || !this.cartReady) return Promise.resolve();
      id = String(id);
      const data = card ? this.variantData(category, card, id) : category.items.get(id);
      if (!data || (delta > 0 && (!data.variant.available || card?.dataset.subscription === 'true'))) return Promise.resolve();
      this.busy = true;
      this.status.textContent = 'Updating your cart and discounts…';
      this.render();
      const task = async () => {
        if (!this.isConnected) return;
        let message = '';
        try {
          // Always obtain current line keys; Shopify can change them when discounts change.
          const cart = await this.refreshCart();
          if (!this.isConnected) return;
          let payload, url;
          if (delta > 0) {
            if (this.count(category) >= category.max || this.remaining(id) <= 0) throw new Error('The quantity limit has been reached.');
            url = this.dataset.addUrl;
            payload = {items:[{id, quantity:1, properties:{_bb_section:this.dataset.section, _bb_category:category.id}}]};
          } else {
            const line = cart.items.find(item => String(item.variant_id || item.id) === id && item.properties?._bb_section === this.dataset.section && item.properties?._bb_category === category.id);
            if (!line) return;
            url = this.dataset.changeUrl;
            payload = {id:line.key, quantity:line.quantity - 1};
          }
          const response = await fetch(url, {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify(payload)});
          const result = await response.json();
          if (!response.ok || result.status >= 400) throw new Error(typeof result.description === 'string' ? result.description : 'Shopify could not update this quantity.');
          message = '';
        } catch (error) {
          message = `${error.message || 'The update could not be confirmed.'} Your cart will be checked before you try again.`;
        } finally {
          // Reconcile even rejected requests: Shopify may have accepted a partial quantity.
          try {
            const cart = await this.refreshCart();
            document.dispatchEvent(new CustomEvent('cart:refresh', {detail:{cart, source:'premium-bundle-builder'}}));
          } catch (_) {
            this.cartReady = false;
            this.querySelector('[data-stock-retry]').hidden = false;
            message = 'We could not confirm the update. Refresh your cart before making another change.';
          }
          this.busy = false;
          if (this.isConnected) { this.status.textContent = message; this.render(); }
        }
      };
      const result = PremiumBundleBuilder.queue.then(task);
      PremiumBundleBuilder.queue = result.catch(() => {});
      return result;
    }
    renderPickerNote(category) {
      const count = this.count(category);
      this.querySelector('[data-picker-note]').textContent = `${count} of ${category.max} selected${count >= category.max ? ' · Category complete' : category.min === 0 ? ' · Optional' : ` · At least ${category.min} required`}`;
    }
    renderProducts(category) {
      if (!category?.content) return;
      const full = this.count(category) >= category.max;
      category.products.forEach(({card, image}) => {
        const select = card.querySelector('[data-variant]');
        const data = this.variantData(category, card, select.value);
        if (!data) return;
        const variant = data.variant;
        const quantity = category.items.get(String(variant.id))?.quantity || 0;
        const subscription = card.dataset.subscription === 'true';
        const selected = [...category.items.values()].filter(item => data.product.variants.some(v => String(v.id) === item.id)).reduce((sum, item) => sum + item.quantity, 0);
        card.classList.toggle('is-selected', selected > 0);
        const badge = card.querySelector('[data-badge]');
        badge.hidden = selected === 0;
        badge.textContent = `${selected} selected`;
        const price = card.querySelector('[data-price]');
        if (price) price.textContent = this.money(variant.price);
        card.querySelector('[data-quantity]').textContent = quantity;
        card.querySelector('[data-change="-1"]').disabled = this.busy || this.locked || !this.cartReady || quantity === 0;
        card.querySelector('[data-change="1"]').disabled = this.busy || this.locked || !this.cartReady || full || !variant.available || subscription || this.remaining(variant.id) <= 0;
        select.disabled = this.busy || this.locked;
        card.querySelector('[data-availability]').textContent = subscription ? 'Subscription required · Not available in this builder' : !variant.available ? 'Sold out' : !this.cartReady ? 'Checking availability…' : this.remaining(variant.id) <= 0 ? 'Stock limit reached · Includes items in your cart' : full ? 'Category limit reached' : 'Available';
        const img = card.querySelector('img');
        const src = variant.featured_image?.src || image;
        if (img && src && img.getAttribute('src') !== src) { img.removeAttribute('srcset'); img.src = src; }
      });
      if (this.quickViewCard && this.quickViewCategory === category && !this.quickView.hidden) this.renderQuickView();
    }
    element(tag, className, text) {
      const el = document.createElement(tag);
      if (className) el.className = className;
      if (text !== undefined) el.textContent = text;
      return el;
    }
    summaryRow(item) {
      const row = this.element('div', 'bb-item');
      row.dataset.itemKey = item.id;
      row.dataset.categoryId = item.categoryId;
      const img = item.image ? this.element('img', 'bb-item-image') : this.element('span', 'bb-item-image');
      if (item.image) { img.src = item.image; img.alt = ''; img.loading = 'lazy'; img.width = 48; img.height = 58; }
      const label = this.element('p', 'bb-item-title', item.title);
      label.append(this.element('span', 'bb-item-meta', [item.variantTitle, item.categoryName].filter(Boolean).join(' · ')));
      const stepper = this.element('div', 'bb-stepper');
      stepper.setAttribute('role', 'group');
      stepper.setAttribute('aria-label', `Quantity for ${item.title}${item.variantTitle ? ', ' + item.variantTitle : ''}, ${item.categoryName}`);
      [-1, 1].forEach((delta, index) => {
        if (index) { const output = this.element('output', '', String(item.quantity)); output.setAttribute('aria-label','Selected quantity'); stepper.append(output); }
        const button = this.element('button', '', delta < 0 ? '−' : '+');
        button.type = 'button'; button.dataset.change = delta;
        button.setAttribute('aria-label', delta < 0 ? 'Decrease quantity' : 'Increase quantity');
        button.disabled = this.busy || this.locked || !this.cartReady || (delta > 0 && (!this.cartReady || !item.variant.available || this.remaining(item.id) <= 0 || this.count(this.categories.get(item.categoryId)) >= this.categories.get(item.categoryId).max));
        stepper.append(button);
      });
      const price = this.element('span', 'bb-item-price');
      if (this.cartReady && item.original > item.final) price.append(this.element('del', 'bb-item-meta', this.money(item.original)));
      price.append(this.element('span', '', this.cartReady ? this.money(item.final) : '—'));
      if (item.discounts.size) label.append(this.element('span', 'bb-item-meta bb-item-offer', [...item.discounts].join(' · ')));
      row.append(img, label, stepper, price);
      return row;
    }
    render() {
      const focused = document.activeElement;
      const focusRow = focused?.closest('[data-item-key]');
      const focusKey = focusRow && this.contains(focusRow) ? {id:focusRow.dataset.itemKey, category:focusRow.dataset.categoryId, delta:focused.dataset.change} : null;
      const items = this.allItems();
      const quantity = items.reduce((sum, item) => sum + item.quantity, 0);
      this.categories.forEach(category => {
        const count = this.count(category);
        category.el.querySelector('[data-count]').textContent = `${count} selected`;
        category.el.querySelector('[data-action-label]').textContent = count ? 'Edit selection' : 'Choose products';
        category.el.querySelector('[data-open]').disabled = this.busy || this.locked;
        const thumbs = category.el.querySelector('[data-thumbs]');
        thumbs.replaceChildren();
        if (this.dataset.thumbnails === 'true') [...category.items.values()].filter(item => item.image).slice(0, 3).forEach(item => {
          const img = this.element('img'); img.src = item.image; img.alt = ''; img.width = 28; img.height = 32; thumbs.append(img);
        });
        this.renderProducts(category);
      });
      const list = this.querySelector('[data-items]');
      list.replaceChildren(...(items.length ? items.map(item => this.summaryRow(item)) : [this.element('p','bb-empty','A few favourites, chosen by you.')]));
      this.querySelector('[data-item-count]').textContent = `${quantity} ${quantity === 1 ? 'item' : 'items'}`;
      this.querySelector('[data-compact-count]').textContent = `· ${quantity} ${quantity === 1 ? 'item' : 'items'}`;
      const total = items.reduce((sum, item) => sum + item.final, 0);
      const original = items.reduce((sum, item) => sum + item.original, 0);
      this.querySelector('[data-total]').textContent = this.cartReady ? this.money(total) : '—';
      const before = this.querySelector('[data-original]');
      before.hidden = !this.cartReady || original <= total;
      before.textContent = this.money(original);
      const otherQuantity = (this.cart?.item_count || 0) - quantity;
      this.querySelector('[data-cart-total]').textContent = this.cartReady && (otherQuantity > 0 || (this.cart?.cart_level_discount_applications || []).length) ? `Cart total: ${this.money(this.cart.total_price)}${otherQuantity > 0 ? ` · Includes ${otherQuantity} other ${otherQuantity === 1 ? 'item' : 'items'}` : ''}` : '';
      const orderDiscounts = this.cart?.cart_level_discount_applications || [];
      this.querySelector('[data-discounts]').textContent = this.cartReady && orderDiscounts.length ? `Applied to your cart: ${orderDiscounts.map(discount => discount.title).join(' · ')}. These savings are reflected in the cart total above.` : '';
      const invalid = [...this.categories.values()].filter(category => category.min > category.max);
      const missing = [...this.categories.values()].filter(category => this.count(category) < category.min);
      this.querySelector('[data-requirements]').textContent = !this.cartReady ? 'Checking cart availability…' : !this.stockValid() ? 'Your selection exceeds available stock. Please reduce the quantity.' : invalid.length ? 'This bundle is currently unavailable. A category minimum exceeds its maximum.' : missing.length ? missing.map(category => `Choose ${category.min - this.count(category)} more from ${category.name}`).join(' · ') : quantity === 0 ? 'Choose a product to start your bundle.' : '';
      this.addButton.disabled = this.busy || this.locked || !this.valid();
      this.addButton.textContent = this.busy ? 'Updating…' : this.buttonText;
      this.setAttribute('aria-busy', String(this.busy));
      if (this.active) this.renderPickerNote(this.categories.get(this.active));
      if (focusKey) {
        const row = [...list.children].find(el => el.dataset.itemKey === focusKey.id && el.dataset.categoryId === focusKey.category);
        const button = row?.querySelector(`[data-change="${focusKey.delta}"]`);
        if (button && !button.disabled) button.focus({preventScroll:true});
        else if (row) row.querySelector('[data-change="-1"]').focus({preventScroll:true});
        else { list.tabIndex = -1; list.focus({preventScroll:true}); }
      }
    }
    async loadMore(category) {
      if (!category || category.loading) return;
      const marker = category.content.querySelector('[data-next]');
      if (!marker) return;
      const button = category.content.querySelector('[data-load]');
      const status = category.content.querySelector('[data-load-status]');
      category.loading = true; button.disabled = true; status.textContent = 'Loading products…';
      try {
        const url = new URL(marker.dataset.next, location.origin);
        if (url.origin !== location.origin) throw new Error();
        url.searchParams.set('section_id', this.dataset.section);
        const response = await fetch(url, {signal:this.controller.signal});
        if (!response.ok) throw new Error();
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const root = doc.getElementById(this.id);
        const categoryEl = [...(root?.querySelectorAll('[data-category]') || [])].find(el => el.dataset.category === category.id);
        const content = categoryEl?.querySelector('template')?.content;
        if (!content) throw new Error();
        this.registerProducts(category, content);
        const grid = category.content.querySelector('.bb-products');
        const newCards = [...content.querySelectorAll('[data-product]')];
        grid.append(...newCards);
        const next = content.querySelector('[data-next]');
        marker.remove();
        if (next) grid.append(next);
        button.hidden = !next;
        this.renderProducts(category);
        status.textContent = `${newCards.length} more products loaded.`;
      } catch (error) {
        if (error.name !== 'AbortError') status.textContent = 'Products could not be loaded. Please try again.';
      } finally { category.loading = false; button.disabled = false; }
    }
    async submit() {
      if (this.busy || !this.valid()) return;
      this.busy = true;
      this.render();
      await this.checkCart();
      this.busy = false;
      this.render();
      if (this.valid()) location.assign(this.dataset.cartUrl);
    }
  }
  customElements.define('premium-bundle-builder', PremiumBundleBuilder);
})();

  } catch(e) { console.error(e); }
})();
})();
